import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '100%'
    },
  },
}));

export default function MultilineTextFields(props) {
  const classes = useStyles();
  const handleChange = event => {
    if(event.target.value.charAt(event.target.value.length-1) !== '\''){
      props.onClickFunction(props.fieldConfiguration.fieldName, event.target.value);
    }
  };

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div style={{backgroundColor:'#fffff'}}>
        <TextField
          style={{backgroundColor:'#fffff'}}
          required
          id="outlined-multiline-static"
          label={props.fieldConfiguration.columnName}
          multiline
          rows="5"
          value={props.value}
          onChange={handleChange}
          variant="outlined"
        />
      </div>
    </form>
  );
}
